import Calendar from './Calendar';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

// Actions
import { getAvailableTimesByDates } from 'store/reducers/availableTimes/actions';
import { setTeamIds, setStartTime } from 'store/reducers/appointment/actions';
import { setAppointmentSelectedDay } from 'store/reducers/userInteractions/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import {
  getFilteredAvailableDays,
  getCalendarSelectedDate,
  getMonthDate,
  getAvailableDay
} from 'store/reducers/availableTimes/selectors';
import { getFirstAvailableTimeSlot } from 'store/reducers/firstAvailableTimeSlot/selectors';
import {
  getStartTime,
  getTransportationOption
} from 'store/reducers/appointment/selectors';
import { getSelectedDay } from 'store/reducers/userInteractions/selectors';
import { getExternalLoanerProvider } from 'store/reducers/dealerSettings/selectors';
import {
  errorLoadingClutchSlots,
  errorLoadingDayTime,
  errorClutchLoanerNotAvailable
} from 'store/reducers/errors/selectors';

const mapStateToProps = state => ({
  startTime: getStartTime(state),
  firstAvailableTimeSlot: getFirstAvailableTimeSlot(state),
  filteredAvailableDays: getFilteredAvailableDays(state),
  calendarSelectedDate: getCalendarSelectedDate(state),
  getAvailableDay: getAvailableDay(state),
  appointmentMonthDate: getMonthDate(state),
  selectedDay: getSelectedDay(state),
  externalLoaner: getExternalLoanerProvider(state),
  transportationOption: getTransportationOption(state),
  errorLoadingClutchSlots: errorLoadingClutchSlots(state),
  requestFailure: errorLoadingDayTime(state),
  errorLoanerNotAvailable: errorClutchLoanerNotAvailable(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAvailableTimesByDates,
      setTeamIds,
      setStartTime,
      setAppointmentSelectedDay,
      gtmUserEvent
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Calendar);



// WEBPACK FOOTER //
// ./src/components/organisms/Calendar/CalendarContainer.js